window.$ = window.jQuery = require('jquery');
require('@popperjs/core');
require('bootstrap/dist/js/bootstrap');
require('slick-slider/slick/slick');
